import React from 'react'
import type { Icon } from 'shared/utils'

const Mustard = (props: Icon) => {
    const { color = 'black', size = 24, className = 'mustard' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <g fillRule="evenodd">
                <path d="M15 19.442c0 .577-.5 1.039-1.038 1.039h-.077s-2.5.346-4.808 0H9c-.577 0-1.038-.5-1.038-1.039v-8.461c0-.577.5-1.039 1.038-1.039h4.962c.577 0 1.038.5 1.038 1.039v8.461zM9.308 6.52h1.731c.23 0 .46-.23.5-.5a.51.51 0 0 0-.5-.5h-.682l.72-2.692h.23l1.078 3.346c.076.231.23.346.46.346h.463v.77h-4v-.77zM8.5 8.942h5.654V8.29H8.5v.653zm6.616.403V7.79c0-.27-.231-.5-.5-.5h-.27V6.02c0-.269-.23-.5-.5-.5h-.577l-1.038-3.27a.478.478 0 0 0-.23-.308c-.078-.038-.655-.384-1.462-.038-.154.077-.27.192-.308.346l-.885 3.23h-.538a.51.51 0 0 0-.5.5v1.31h-.346c-.27 0-.5.23-.5.5v1.653a.48.48 0 0 0 .055.215c-.316.352-.517.81-.517 1.324v8.461c0 1.078.885 1.962 1.962 2a16.81 16.81 0 0 0 2.384.155c1.346 0 2.423-.116 2.693-.155 1.077 0 1.961-.922 1.961-2v-8.461c0-.665-.353-1.27-.884-1.636z" />
                <path d="M9.539 11.02c-.27 0-.5.23-.5.5v7.345c0 .27.23.5.5.5.269 0 .5-.23.5-.46V11.52c0-.27-.231-.5-.5-.5" />
            </g>
        </svg>
    )
}

export { Mustard }
